export const resources = {
  UploadContainerUploadFilesError: ''
};
